import { TrackingPersona } from 'src/hooks'
import { usePersona } from 'src/hooks/usePersona'

export const useKnowledgeBaseUrl = () => {
  const persona = usePersona()

  const knowledgeBaseUrlMapper: Record<TrackingPersona, string | undefined> = {
    [TrackingPersona.BUYER]: window?.KNOWLEDGE_BASE_BUYER_URL,
    [TrackingPersona.SELLER]: window?.KNOWLEDGE_BASE_SELLER_URL,
    [TrackingPersona.CENTRAL]: window?.KNOWLEDGE_BASE_CENTRAL_URL,
  }

  const knowledgeBaseUrl = persona && knowledgeBaseUrlMapper[persona]

  return knowledgeBaseUrl
}
